import { Badge, Col, Progress, Row } from "reactstrap";
import { H3, Image, LI, P, UL } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { Comment, Done, Issues, Resolved } from "../../../Constant";
import { commonProjectInterFace } from "../../../Type/ProjectLayoutType";

export const CommonProjectListCard = ({ item }: commonProjectInterFace) => {
  return (
    <Col xxl="4" lg="4" md="6" className="box-col-33">
      <div className="project-box">
        <Badge color={item.badge === 'Done' ? 'success' : 'primary'}>{item.badge}</Badge>
        <H3>{item.title}</H3>
        <div className="d-flex">
          <Image className="img-20 me-1 rounded-circle" src={dynamicImage(`user/${item.image}`)} alt="" />
          <div className="flex-grow-1"><P>{item.sites}</P></div>
        </div>
        <P>{item.description}</P>
        <Row className="details">
          <Col xs="6"><span>{Issues} </span></Col>
          <Col xs="6" className="font-primary">{item.issue}</Col>
          <Col xs="6"><span>{Resolved}</span></Col>
          <Col xs="6" className="font-primary">{item.resolved}</Col>
          <Col xs="6"><span>{Comment}</span></Col>
          <Col xs="6" className="font-primary">{item.comment}</Col>
        </Row>
        <div className="customers">
          <UL className="simple-list d-flex align-items-center flex-row">
            <LI className="d-inline-block"><Image className="img-30 rounded-circle" src={dynamicImage(`user/${item.customers_img1}`)} alt="" /></LI>
            <LI className="d-inline-block"><Image className="img-30 rounded-circle" src={dynamicImage(`user/${item.customers_img2}`)} alt="" /></LI>
            <LI className="d-inline-block"><Image className="img-30 rounded-circle" src={dynamicImage(`user/${item.customers_img3}`)} alt="" /></LI>
            <LI className="d-inline-block ms-2"><P className="f-12">{`+${item.like} More`}</P></LI>
          </UL>
        </div>
        <div className="project-status mt-4">
          <div className="d-flex mb-0">
            <P>{item.progress}%</P>
            <div className="flex-grow-1 text-end"><span>{Done}</span></div>
          </div>
          {item.progress === 100 ? <Progress className='sm-progress-bar' color='success' value={item.progress} style={{ height: '5px' }} /> : <Progress className='sm-progress-bar' animated striped color='primary' value={item.progress} style={{ height: '5px' }} />}
        </div>
      </div>
    </Col>
  );
};
